// ==============================|| OVERRIDES - DIALOG ||============================== //

export default function Dialog(theme) {
    return {
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    backgroundColor: '#fafafb',
                    fontWeight: 400,
                    marginBottom: '1rem',
                    borderBottom: '1px solid #ccc'
                },
            }
        }
    };
}
